import { NICmsBlock } from '@icms/core/resource/block/icms-block';
export namespace NProductSizeGuideModal {
    export const BLOCK_ID = 'size-guide-modal';
    export interface IBlockData extends NICmsBlock.IData<IBlockDataContent> {}
    export interface IBlockDataContent {
        title: string;
        subtitle?: string;
        tables: ISizeGuideModalTable[];
        copy?: string;
        imageTitle?: string;
        image?: string;
        imageCaption?: string;
    }
    export interface ISizeGuideModalTable {
        toggleVisibility?: boolean;
        toggleTitle?: string;
        toggleOptionFirst?: string;
        toggleOptionSecond?: string;
        tableCopy?: string;
        rows?: ISizeGuideModalTableRow[];
    }
    export interface ISizeGuideModalTableRow {
        columns?: ISizeGuideModalTableColumn[];
    }
    export interface ISizeGuideModalTableColumn {
        valueFirst?: string;
        valueSecond?: string;
    }
}
